<section class="py-12 md:py-16 overflow-hidden">
  <div class="container relative">

    @if (loading()) {
      <!-- Skeleton Loader Premium -->
      <div class="w-full h-[200px] md:h-[320px] rounded-3xl bg-gray-100 animate-pulse flex items-center justify-center">
        <div class="flex flex-col items-center gap-4">
          <div class="w-12 h-12 rounded-full bg-gray-200"></div>
          <div class="w-48 h-4 bg-gray-200 rounded"></div>
          <div class="w-32 h-3 bg-gray-200 rounded"></div>
        </div>
      </div>
    } @else if (ads().length > 0) {
      <swiper-container braidsbookSwiper init="false" [swiperOptions]="config()"
                        class="rounded-3xl shadow-xl shadow-main-100/20">
        @for (ad of ads(); track ad.id) {
          <swiper-slide>
            <div class="relative w-full h-[200px] md:h-[320px] bg-neutral-900 overflow-hidden group">
              <!-- Background Image fallback -->
              @if (ad.images && ad.images.length > 0) {
                <img [src]="ad.images[0]" [alt]="ad.title"
                     class="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:scale-105 transition-transform duration-700">
                <div class="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent"></div>
              } @else {
                <div class="absolute inset-0 bg-gradient-to-br from-main-900 to-main-700 opacity-90"></div>
                <div class="absolute inset-0 opacity-10"
                     style="background-image: url('https://www.transparenttextures.com/patterns/carbon-fibre.png');"></div>
              }

              <!-- Content wrapper -->
              <div class="relative h-full container flex flex-col justify-center px-10 md:px-20 text-white gap-3">
                <div class="flex flex-col gap-1">
                  <span class="text-main-400 font-bold tracking-widest text-xs md:text-sm uppercase">
                     {{'HOME.AD_BANNER.PROMOTION' | translate }}
                  </span>
                  <h2 class="text-2xl md:text-6xl font-black leading-tight max-w-2xl">{{ ad.title }}</h2>
                </div>
                <p class="text-sm md:text-xl text-gray-200 max-w-xl font-light leading-relaxed">
                  {{ ad.content }}
                </p>
                @if (ad.endMessage) {
                  <div class="flex items-center gap-2 text-xs md:text-sm text-white/70 italic mt-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="size-4" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"/>
                      <polyline points="12 6 12 12 16 14"/>
                    </svg>
                    <span>{{ ad.endMessage }}</span>
                  </div>
                }
              </div>

              <!-- Decorative element -->
              <div class="absolute right-10 bottom-10 hidden md:block">
                <div class="w-20 h-20 border-t-2 border-r-2 border-white/20 rounded-tr-3xl"></div>
              </div>
            </div>
          </swiper-slide>
        }
      </swiper-container>
      <div class="ad-pagination"></div>
    }
  </div>
</section>
